import { render, staticRenderFns } from "./TreeStock.vue?vue&type=template&id=1c6bff93&scoped=true"
import script from "./TreeStock.vue?vue&type=script&lang=js"
export * from "./TreeStock.vue?vue&type=script&lang=js"
import style0 from "./TreeStock.vue?vue&type=style&index=0&id=1c6bff93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6bff93",
  null
  
)

export default component.exports